import { useEffect, useState } from 'react'
import { useAppStore } from '../../store/app'
import { getOnboardingFacilitator, setOnboardingFacilitator } from '../../api/ws'
import { SectionHeader, Group, TappableRow } from '../account/AccountComponents'
import '../account/AccountStyles.css'

// Designate the household's Onboarding Facilitator (onboarding LW-4). The chosen
// agent is the LLM that reasons provisioning proposals when new agents or
// resources are added; none designated = onboarding stays quiet (degrade-to-
// nothing). Owner-gated in HouseholdScreen.
export function FacilitatorSection() {
  const organizationID = useAppStore((s) => s.organizationID)
  const agents = useAppStore((s) => s.agentInstances)

  const [current, setCurrent] = useState<string>('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!organizationID) return
    getOnboardingFacilitator(organizationID)
      .then((r) => {
        if (!r.error) setCurrent(r.ai_agent_instance_id ?? '')
      })
      .catch(() => {})
  }, [organizationID])

  // Filter on status, not retired_at — the client's retired_at is often undefined
  // for active agents (server omits it), so `=== null` would drop everything.
  const candidates = agents.filter((a) => a.status !== 'retired' && !a.is_temp)

  function choose(agentID: string) {
    if (!organizationID || saving) return
    const prev = current
    setSaving(true)
    setError(null)
    setCurrent(agentID) // optimistic
    setOnboardingFacilitator(organizationID, agentID)
      .then((r) => {
        if (r.error) {
          setError(r.error)
          setCurrent(prev)
        }
      })
      .catch((e) => {
        setError(String(e))
        setCurrent(prev)
      })
      .finally(() => setSaving(false))
  }

  return (
    <>
      <SectionHeader>Onboarding Facilitator</SectionHeader>
      <p className="about__hint">
        The agent that suggests setup for new agents and resources — it reasons
        about what each new hire needs and proposes it for your review. Give it
        discovery access so it can see the household. With none chosen, onboarding
        stays quiet.
      </p>
      <Group>
        <TappableRow label="None" onClick={() => choose('')}>
          {current === '' ? '✓' : ''}
        </TappableRow>
        {candidates.map((a) => (
          <TappableRow key={a.id} label={a.name} onClick={() => choose(a.id)}>
            {current === a.id ? '✓' : ''}
          </TappableRow>
        ))}
      </Group>
      {error && (
        <p className="about__hint" style={{ color: 'var(--danger)' }}>
          {error}
        </p>
      )}
    </>
  )
}
